(function () {

    'use strict';

    var ngModule = angular.module('breakmarkApp');

	/*
		This directive provides a product property editor. It renders the
		property name and attributes and provides the option to delete. It
		requires access to the parent product.
    */

	ngModule.directive('productProperties', function ($uibModal) {
		return {
			scope: {
				product: '='
			},
			templateUrl: 'directives/productProperties/table.html',
			controller: function($scope) {

				/* Function to remove the a given property from the product. */
				$scope.delete = function(idx) {

                    let scope = $scope; // need this inside the controller for the modal

                    let modalInstance = $uibModal.open({
                        animation: true,
                        backdrop: 'static',
                        // windowTopClass: 'woooooooot',
                        windowClass: 'topmost',
                        backdropClass: 'topmost',
                        template: `
                            <div class="modal-header">
                                <h3 class="modal-title">Remove this property?</h3>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-default" type="button" ng-click="cancel()">Cancel</button>
                                <button class="btn btn-danger" type="button" ng-click="delete()">Delete</button>
                            </div>`,
                        controller: function($scope, $uibModalInstance, idx) {

                            $scope.delete = function () {

                                scope.product.properties.splice(idx, 1);

                                $uibModalInstance.close(idx);
                            };

                            $scope.cancel = function () {
                                $uibModalInstance.dismiss('cancel');
                            };

                        },
                        resolve: {
                            idx: function() {
                                return idx;
                            }
                        },
                        size: 'sm'
                    });
				};
			}
		};
	});

})();
